export const MOBILE_LAYER = {
  MAP_BUTTON: 103,
  NAVIGATION: 102,
  ROOM_LIST: 101,
  MAP: 100, // 네이버 지도의 컨트롤 z-index 값
}
